import React from 'react';
import { IRecoverPasswordComponentProps } from './recover-password.props';
import { IRecoverPasswordComponentState } from './recover-password.state';
import { validator, ValidationResult, validateObject } from '../../ioip/sdk/base';
import { PqrWebService } from '../../services/services';
import { ComboBox, TextField, IComboBoxOption, PrimaryButton, DefaultButton, Label } from "@fluentui/react";

export class RecoverPasswordComponent extends React.Component<IRecoverPasswordComponentProps, IRecoverPasswordComponentState> {

  private _pqrWebService: PqrWebService;

  private _validationsStep1: { [ key: string ]: any[] } = {
    IdTipoIdentificacion: [
      validator.invalid(0, 'Campo requerido')
    ],
    Identificacion: [
      validator.required(true),
      validator.maxLength(128)
    ],
    Email: [
      validator.required(true),
      validator.maxLength(128),
      validator.email(),
      validator.custom(this._checkEmail.bind(this))
    ],
    Email2: [
      validator.required(true),
      validator.maxLength(128),
      validator.email(),
      validator.custom(this._checkEmail.bind(this))
    ],
    // IdPreguntaSecreta: [ validator.invalid(0, 'Campo requerido') ],
    // RespuestaSecreta: [ validator.required(true), validator.maxLength(128) ]
  };
  private _validationsStep2: { [ key: string ]: any[] } = {
    Password: [
      validator.required(true),
      validator.maxLength(128),
      validator.custom(this._checkPassword.bind(this))
    ],
    Password2: [
      validator.required(true),
      validator.maxLength(128),
      validator.custom(this._checkPassword.bind(this))
    ],
    CodigoVerificacion: [
      validator.required(true),
      validator.maxLength(256),
    ]
  };

  constructor(props: any) {
    super(props);
    this.state = {
      model: {
        Email: '',
        Email2: '',
        RespuestaSecreta: '',
        IdPreguntaSecreta: 0,
        IdTipoIdentificacion: 0,
        Identificacion: '',
        Password: '',
        Password2: '',
        CodigoVerificacion: ''
      },
      errors: {},
      preguntasCO: [],
      showValidationCodeField: false,
      tiposIdentificacionCO: []
    }
    this._pqrWebService = new PqrWebService();
  }

  async componentDidMount(): Promise<void> {
    const result = await Promise.all([
      this._pqrWebService.getAllQuestionsAsync(),
      this._pqrWebService.getAllIdentificationTypesAsync()
    ]);
    this.setState({
      preguntasCO: result[ 0 ].map(o => ({ key: o.IdPreguntaSecreta, text: o.Nombre })),
      tiposIdentificacionCO: result[ 1 ].map(o => ({ key: o.IdTipoIdentificacion, text: o.Nombre }))
    });
  }

  render(): JSX.Element {
    return <div className='ms-Grid'>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12'>
          <h1 className="ms-font-xl ms-fontWeight-semibold">Olvidé mi contraseña</h1>
        </div>
      </div>
      {
        this.state.showValidationCodeField === false && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <ComboBox
              label='Tipo de identificación'
              selectedKey={this.state.model.IdTipoIdentificacion}
              onChange={(_, value) => this._onChangeComboBox('IdTipoIdentificacion', value)}
              options={this.state.tiposIdentificacionCO}
              useComboBoxAsMenuWidth={true}
              errorMessage={this.state.errors[ 'IdTipoIdentificacion' ]}
              required={true}
            />
          </div>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder='Identificación'
              label='Identificación'
              maxLength={128}
              required={true}
              onChange={(_, value) => this._onChangeTextField('Identificacion', value)}
              errorMessage={this.state.errors[ 'Identificacion' ]}
              value={this.state.model.Identificacion}
            />
          </div>
        </div>
      }
      {
        this.state.showValidationCodeField === false && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder='Correo eléctronico'
              label='Correo eléctronico'
              maxLength={128}
              required={true}
              onChange={(_, value) => this._onChangeTextField('Email', value)}
              errorMessage={this.state.errors[ 'Email' ]}
              value={this.state.model.Email}
            />
          </div>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder='Confirmar correo eléctronico'
              label='Confirmar correo eléctronico'
              maxLength={128}
              required={true}
              onChange={(_, value) => this._onChangeTextField('Email2', value)}
              errorMessage={this.state.errors[ 'Email2' ]}
              value={this.state.model.Email2}
            />
          </div>
        </div>
      }
      {/* {
        this.state.showValidationCodeField === false && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <ComboBox
              label='Pregunta secreta'
              selectedKey={this.state.model.IdPreguntaSecreta}
              onChange={(_, value) => this._onChangeComboBox('IdPreguntaSecreta', value)}
              options={this.state.preguntasCO}
              useComboBoxAsMenuWidth={true}
              errorMessage={this.state.errors[ 'IdPreguntaSecreta' ]}
            />
          </div>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder='Respuesta secreta'
              label='Respuesta secreta'
              maxLength={15}
              required={true}
              type='password'
              onChange={(_, value) => this._onChangeTextField('RespuestaSecreta', value)}
              errorMessage={this.state.errors[ 'RespuestaSecreta' ]}
              value={this.state.model.RespuestaSecreta}
            />
          </div>
        </div>
      } */}
      {
        this.state.showValidationCodeField === false && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12'>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
              <small style={{ color: 'red' }}> {this.state.errors[ 'error-paso1' ]}</small>
            </div>
          </div>
        </div>
      }
      {
        this.state.showValidationCodeField === true && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12'>
            <Label>A continuación, ingrese el código de verificación que se ha enviado al correo {this.state.model.Email} y digite una nueva clave para el acceso al sistema.</Label>
          </div>
        </div>
      }
      {
        this.state.showValidationCodeField === true && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12'>
            <TextField
              placeholder='Código de verificación'
              label='Código de verificación'
              maxLength={32}
              required={true}
              onChange={(_, value) => this._onChangeTextField('CodigoVerificacion', value)}
              errorMessage={this.state.errors[ 'CodigoVerificacion' ]}
              value={this.state.model.CodigoVerificacion}
            />
          </div>
        </div>
      }
      {
        this.state.showValidationCodeField === true && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder='Contraseña'
              label='Contraseña'
              maxLength={16}
              required={true}
              type='password'
              onChange={(_, value) => this._onChangeTextField('Password', value)}
              errorMessage={this.state.errors[ 'Password' ]}
              value={this.state.model.Password}
            />
          </div>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder='Confirmar contraseña'
              label='Confirmar contraseña'
              maxLength={16}
              required={true}
              type='password'
              onChange={(_, value) => this._onChangeTextField('Password2', value)}
              errorMessage={this.state.errors[ 'Password2' ]}
              value={this.state.model.Password2}
            />
          </div>
        </div>
      }
      {
        this.state.showValidationCodeField === true && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12'>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
              <small style={{ color: 'red' }}> {this.state.errors[ 'error-paso2' ]}</small>
            </div>
          </div>
        </div>
      }
      {
        this.state.showValidationCodeField === false && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'right' }}>
            <PrimaryButton
              text='Recuperar cuenta'
              onClick={this._recoverPasswordAsync.bind(this)}
            />
            <span>&nbsp;&nbsp;</span>
            <DefaultButton
              text='Volver a inicio'
              href='#/home'
            />
          </div>
        </div>
      }
      {/* {
        this.state.showValidationCodeField === false && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px' }}>
            <a className="link" href='#/recover-question'>Recuperar pregunta secreta</a>
          </div>
        </div>
      } */}
      {
        this.state.showValidationCodeField === true && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'right' }}>
            <PrimaryButton
              text='Restablecer contraseña'
              onClick={this._changePasswordAsync.bind(this)}
            />
            <span>&nbsp;&nbsp;</span>
            <DefaultButton
              text='Volver a inicio'
              href='#/home'
            />
          </div>
        </div>
      }
    </div>
  }

  private _checkPassword(): ValidationResult {
    const result: ValidationResult = new ValidationResult();
    if (this.state.model.Password != this.state.model.Password2) {
      result.hasError = true;
      result.errorMessage = 'Las constraseñas establecidas no coinciden';
    }
    return result;
  }

  private _checkEmail(): ValidationResult {
    const result: ValidationResult = new ValidationResult();
    if (this.state.model.Email.toLowerCase() != this.state.model.Email2.toLowerCase()) {
      result.hasError = true;
      result.errorMessage = 'Las direcciones de correo electrónico no coinciden';
    }
    return result;
  }

  private _updateErrors(errors: { [ key: string ]: string }): void {
    this.setState({ errors });
  }

  private async _recoverPasswordAsync(): Promise<void> {
    if (validateObject(this.state.model, this._validationsStep1, this._updateErrors.bind(this))) {
      try {
        const result = await this._pqrWebService.recoverPasswordAsync(this.state.model);
        if (result === true) {
          this.setState({
            showValidationCodeField: true
          });
        }
      } catch (ex) {
        this.setState({
          errors: {
            'error-paso1': 'Ocurrió un error al recuperar la contraseña, por favor verifique que sus datos sean correctos.'
          }
        });
      }
    }
  }

  private async _changePasswordAsync(): Promise<void> {
    if (validateObject(this.state.model, this._validationsStep2, this._updateErrors.bind(this))) {
      try {
        const result = await this._pqrWebService.changePasswordAsync(this.state.model);
        if (result === true) {
          window.location.href = '#home';
        }
      } catch (ex) {
        const error = `Ocurrió un error : ${(ex as any).exceptionMessage}`;
        this.setState({
          errors: {
            'error-paso2': error//'El código de verificación es incorrecto.'
          }
        });
      }
    }
  }

  private _onChangeComboBox(property: string, option?: IComboBoxOption, index?: number, value?: string, submitPendingValueEvent?: any): void {
    const state = {
      ...this.state,
      model: {
        ...this.state.model,
        [ property ]: Number(option.key)
      }
    };
    this.setState(state);
  }

  private _onChangeTextField(property: string, value: string): void {
    const state = {
      model: {
        ...this.state.model,
        [ property ]: value
      }
    };
    this.setState(state);
  }


}